import { useDispatch, useSelector } from "react-redux";
import "./LPListingContentComponent.scss";
import ListingFilterSectionComponent from "../ListingFilterSection/ListingFilterSectionComponent";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getMyOBLPListing,
  getMyOBLPListingClear,
  getNONOBLPListing,
  getNONOBLPListingClear,
  getNonMyOBLPListing,
  getNonMyOBLPListingClear,
  getOBLPListing,
} from "../../../../redux/learningPath/actions";
import CONFIG from "../../../../utils/config";
import API_LIST from "../../../../utils/apiList";
import {
  ProductCardPriceInfo,
  SessionKeys,
  convertTimeFormat,
  convertTimeInHourAndMin,
  getProcureInfo,
  goToLPDetailUtil,
} from "../../../../utils/AppUtils";
import { getProductCategories } from "../../../../redux/courses/actions";
import _ from "lodash";
import ProductCardComponent from "../../ProductCard/ProductCardComponent";
import NotFoundComponent from "../../NotFound/NotFoundComponent";
import EventSliderFilterSection from "../../Event/EventSliderFilter";
import { useTranslation } from "react-i18next";

const LPListingContentComponent = (props) => {
  const { isAllLP, isMyOBLP, isMyLP, tabKey } = props;
  const { t } = useTranslation();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let providerId = "";
  let allPartners = "";
  let providerName = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    providerId = paramsReq.provider_id;
    allPartners = paramsReq?.allPartners;
    providerName = paramsReq?.provider_name;
  }

  const [selectedPartner, setSelectedPartner] = useState(
    providerId ? "" : "all"
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const observer = useRef();

  const oblpListing = useSelector((state) => state.learningPath.oblpListing);
  const nonOblpListing = useSelector(
    (state) => state.learningPath.nonOblpListing
  );
  const myOblpListing = useSelector(
    (state) => state.learningPath.myOblpListing
  );
  const myNonOblpListing = useSelector(
    (state) => state.learningPath.myNonOblpListing
  );
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [placeHolder, setPlaceHolder] = useState(t("Search for Action Path"));
  const [lpListing, setLPListing] = useState(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  const [apiListing, setAPIListing] = useState([]);
  const [clearSearch, setClearSearch] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortOption, setSortOption] = useState([
    { value: 1, label: t("Name (A to Z)") },
    { value: 2, label: t("Name (Z to A)") },
    { value: 3, label: t("New To Old") },
    { value: 4, label: t("Old To New") },
  ]);
  const [selectedSort, setSelectedSort] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [pageNum, setPageNum] = useState(0);
  const [pageSize, setPageSize] = useState(CONFIG.PAGINATION_PAGE_SIZE);
  const [hasNoMore, setHasNoMore] = useState(true);
  const [currentKey, setCurrentKey] = useState("");
  const [isResetDone, setIsResetDone] = useState(false);
  const [msgLine, setMsgLine] = useState(t("Nothing here, yet."));

  useEffect(() => {
    async function checkTabKey() {
      if (tabKey !== currentKey) {
        console.log(tabKey);
        setCurrentKey(tabKey);
        await resetAll();
        setIsResetDone(true);
        if (!isLoading) {
        }
      }
    }
    checkTabKey();
  }, [tabKey]);

  useEffect(() => {
    console.log(
      "DEFAULT SETTINGS",
      isAllLP,
      isMyOBLP,
      isMyLP,
      pageNum,
      selectedSort,
      isResetDone,
      searchText
    );
    if (isResetDone) {
      console.log("Return2: ");
      setIsResetDone(false);
      setIsFetching(true);
      fetchAPI();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    searchText,
    pageNum,
    isAllLP,
    isMyOBLP,
    isMyLP,
    selectedPartner,
    activeLanguage
  ]);

  useEffect(() => {
    sortFunc();
  }, [selectedSort]);

  const sortFunc = async (searchTxt) => {
    await resetAll(true, false);
    fetchAPI();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setSortOption([
      { value: 1, label: t("Name (A to Z)") },
      { value: 2, label: t("Name (Z to A)") },
      { value: 3, label: t("New To Old") },
      { value: 4, label: t("Old To New") },
    ]);
  }, [activeLanguage]);
  useEffect(() => {
    if (
      !_.isEmpty(nonOblpListing) ||
      !_.isEmpty(myOblpListing) ||
      !_.isEmpty(myNonOblpListing)
    ) {
      let responseList = nonOblpListing;
      if (isMyOBLP) {
        responseList = myOblpListing;
      } else if (isMyLP) {
        responseList = myNonOblpListing;
      }
      console.log(nonOblpListing);
      if (responseList.status === "success") {
        const payload = responseList.payload?.data;
        if (!_.isEmpty(payload)) {
          console.log(payload);
          formatLPData(payload);
        } else {
          setLPListing([]);
          setMsgLine(
            searchText ? t("Nothing here, as per search.") : t("Nothing here, yet.")
          );
        }
      } else {
        setLPListing([]);
      }
      setClearSearch(false);
      setIsLoading(false);
      dispatch(getNONOBLPListingClear());
      dispatch(getMyOBLPListingClear());
      dispatch(getNonMyOBLPListingClear());
    }
  }, [nonOblpListing, myOblpListing, myNonOblpListing]);

  useEffect(() => {
    if (_.isEmpty(apiListing) && !isFetching) {
      console.log("DEFAULT SETTING RESET VALUE");
      setIsResetDone(true);
    }
  }, [apiListing]);

  useEffect(() => {
    console.log("DEFAULT SETTING END page num", pageNum);
  }, [pageNum]);

  const fetchAPI = () => {
    if (isAllLP) {
      setPlaceHolder(t("Search for Action Path"));
      fetchNonOBLPList();
    } else if (isMyOBLP) {
      setPlaceHolder(t("Search for onboarding path"));
      fetchMyOBLPList();
    } else if (isMyLP) {
      setPlaceHolder(t("Search in my Action Path"));
      fetchNonMyOBLPList();
    }
  };

  const resetAll = async (resetSearch = true, resetSort = true) => {
    console.log("DEFAULT SETTING RESET ALL CALLED");
    setIsLoading(true);
    setLPListing(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsFetching(false);
    setHasNoMore(true);
    resetSearch && setSearchText("");
    resetSearch && setClearSearch(true);
    setTotalRecords(0);
    resetSort && setSelectedSort(1);
    setPageNum(0);
    setAPIListing([]);
  };

  const fetchOBLPList = () => {
    dispatch(
      getOBLPListing({
        URL: `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_ALL_LP_LISTING}`,
        payload: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          sort: selectedSort,
          page_size: pageSize,
          page: tabKey !== currentKey ? 0 : pageNum,
          search: searchText,
          is_onboarding: 1,
          language: activeLanguage ? activeLanguage : "",
        },
        isJSON: true,
        method: "post",
      })
    );
  };

  const fetchMyOBLPList = () => {
    dispatch(
      getMyOBLPListing({
        URL: `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_MY_LP_LISTING}`,
        payload: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          sort: selectedSort,
          page_size: pageSize,
          page: tabKey !== currentKey ? 0 : pageNum,
          search: searchText,
          is_onboarding: 1,
          language: activeLanguage ? activeLanguage : "",
        },
        isJSON: true,
        method: "post",
      })
    );
  };

  const fetchNonOBLPList = () => {
    console.log("FETCH NON OBLP LIST");
    dispatch(
      getNONOBLPListing({
        URL: `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_ALL_LP_LISTING}`,
        payload: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          sort: selectedSort,
          page_size: pageSize,
          page: tabKey !== currentKey ? 0 : pageNum,
          search: searchText,
          is_onboarding: 0,
          provider_id: providerId
            ? providerId
            : selectedPartner != "all"
            ? selectedPartner
            : "",
          isAll: allPartners
            ? selectedPartner != "all"
              ? false
              : true
            : false,
          language: activeLanguage ? activeLanguage : "",
        },
        isJSON: true,
        method: "post",
      })
    );
  };

  const fetchNonMyOBLPList = () => {
    console.log("FETCH NON MY OBLP LIST");
    dispatch(
      getNonMyOBLPListing({
        URL: `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_MY_LP_LISTING}`,
        payload: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          sort: selectedSort,
          page_size: pageSize,
          page: tabKey !== currentKey ? 0 : pageNum,
          search: searchText,
          is_onboarding: 0,
          provider_id: providerId
            ? providerId
            : selectedPartner != "all"
            ? selectedPartner
            : "",
          isAll: allPartners
            ? selectedPartner != "all"
              ? false
              : true
            : false,
          language: activeLanguage ? activeLanguage : "",
        },
        isJSON: true,
        method: "post",
      })
    );
  };

  const goToLPDetail = (lpInfo) => {
    let paramsReq = {
      lp_id: lpInfo.id,
      is_level: "false",
      source: lpInfo?.origin,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    navigate(`/lpDetail?c=${encodedUrl}`);
  };

  const formatLPData = (lpData) => {
    setIsResetDone(true);
    let lpArr = [];
    let records = lpData.records;
    setTotalRecords(lpData.total_records);
    for (let lp of records) {
      let tags = [];
      let logoURL = "";
      let btnTitle = t("Explore");
      if (_.toNumber(lp.learn_progress) === 100) {
        btnTitle = t("Revisit");
      }
      if (
        _.toNumber(lp.learn_progress) > 1 &&
        _.toNumber(lp.learn_progress) < 100
      ) {
        btnTitle = t("Resume");
      }
      if (!_.isEmpty(lp.provider)) {
        tags.push(lp.provider.provider_display_name);
        logoURL = lp.provider.provider_img;
      }

      if (lp.product_type === "bundle") {
        tags.push(t("Combo"));
      } else {
        tags.push(`${isMyOBLP ? t("onboarding") : t("Action Path")}`);
      }

      if (lp.learningpath_count) {
        tags.push(
          `${lp.learningpath_count} ${t("Action Path")}${
            lp.learningpath_count > 1 ? "s" : ""
          }`
        );
      }
      if (lp.course_count) {
        tags.push(`${lp.course_count} ${t("Course")}${lp.course_count > 1 ? "s" : ""}`);
      }
      if (lp.video_count) {
        tags.push(`${lp.video_count} ${t("Video")}${lp.video_count > 1 ? "s" : ""}`);
      }
      if (lp.level_count) {
        tags.push(`${lp.level_count} ${t("Level")}${lp.level_count > 1 ? "s" : ""}`);
      }
      if (lp.event_count) {
        tags.push(`${lp.event_count} ${t("Event")}${lp.event_count > 1 ? "s" : ""}`);
      }
      if (lp.duration) {
        tags.push(`${convertTimeFormat(lp.duration, true)}`);
      }
      let priceInfo = getProcureInfo(lp.purchased_info);
      lp.priceInfo = priceInfo;

      if (providerId) {
        lp.provider_id = providerId;
        lp.provider_name = providerName;
      }

      lpArr.push({
        id: lp?.id,
        ecom_id: lp?.ecom_id,
        is_like: lp?.is_like ? lp?.is_like : false,
        is_bookmark: lp?.is_bookmark ? lp?.is_bookmark : false,
        is_wishlist: lp?.is_addtowishlist,
        dbId: lp?.list_id,
        productType: "learningpath",
        productOrigin: lp?.origin,
        title: lp.name,
        logoURL: logoURL,
        logoAlText: isMyOBLP ? "OB" : "LP",
        bannerURL: lp.thumbnail,
        tagsArray: tags,
        description: lp.description,
        duration: "",
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: true,
        showBody: false,
        showFooter: true,
        progress: lp.learn_progress,
        btnTitle: btnTitle,
        btnAction: () => goToLPDetailUtil(lp, navigate, isMyOBLP ? 2 : 0),
        descAction: () => {},
        bannerAction: () => goToLPDetailUtil(lp, navigate, isMyOBLP ? 2 : 0),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        isLoading: false,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        isBundle: lp?.product_type === "bundle",
        bundles: lp?.bundles,
        status: lp?.status,
      });
    }

    let newLPArr = lpArr;
    console.log("DEFAULT SETTING PAGENUM", pageNum);
    if (pageNum > 0) {
      newLPArr = [...apiListing, ...lpArr];
      console.log(newLPArr);
      setLPListing(newLPArr);
      setAPIListing(newLPArr);
      setIsFetching(false);
    } else {
      setLPListing(lpArr);
      setAPIListing(lpArr);
    }
    console.log("DEFAULT SETTING LENGTH", newLPArr.length);
    console.log("DEFAULT SETTING LENGTH", lpData.total_records);
    if (lpData.total_records === newLPArr.length) {
      setIsFetching(false);
      setHasNoMore(true);
    } else {
      setHasNoMore(false);
      setIsFetching(false);
    }
    if (_.isEmpty(newLPArr)) {
      console.log("EMPTY ARR");
      setMsgLine(
        searchText ? t("Nothing here, as per search.") : t("Nothing here, yet.")
      );
    }
  };

  const paginateCB = useCallback(
    (node) => {
      console.log(
        "DEFAULT SETTING iS FETCHING IS LOADING",
        isFetching,
        isLoading
      );
      if (isFetching || isLoading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        console.log("DEFAULT SETTING NO MORE", hasNoMore);
        if (entries[0].isIntersecting && !hasNoMore) {
          setIsFetching(true);
          // console.log(
          //   "DEFAULT SETTING End of file",
          //   totalRecords,
          //   lpListing.length,
          //   pageNum,
          //   isLoading,
          //   isFetching
          // );
          setPageNum((pageNum) => pageNum + 1);
          setLPListing([...lpListing, ...CONFIG.INITIAL_PRODUCT_CARD_DATA]);
        }
      });

      if (node) observer.current.observe(node);
      console.log(node);
    },
    [isLoading, isFetching, hasNoMore, pageNum]
  );

  const searchInLP = async (searchTxt) => {
    setSearchText(searchTxt);
    await resetAll(false, false);
  };

  return (
    <>
      {allPartners ? (
        <EventSliderFilterSection
          selectedPartner={selectedPartner}
          setSelectedPartner={setSelectedPartner}
        />
      ) : (
        ""
      )}
      <ListingFilterSectionComponent
        categoryList={() => {}}
        selectedCatIds={() => {}}
        selectedSubCatIds={() => {}}
        subCatList={() => {}}
        checkBoxOnChange={() => {}}
        onSelectSubCat={() => {}}
        onSearchClicked={searchInLP}
        searchText={searchText}
        setSearchText={setSearchText}
        searchPlaceHolder={placeHolder}
        showSearch={true}
        showSort={true}
        showFilter={false}
        showCategories={false}
        sortOption={sortOption}
        filterOption={[]}
        sortSelected={selectedSort}
        setSelectedSort={setSelectedSort}
        isLoading={isLoading}
        setSelectedFilter={() => {}}
        clearSearch={clearSearch}
        entityType={"lp"}
      />
      <div className="mgt-3">
        {isLoading || !lpListing.length ? (
          ""
        ) : (
          <span className="count-text-head">
            {t("We found")} {totalRecords}{" "}
            {isMyOBLP ? "onboarding path" : "Action Path"}
            {totalRecords > 1 ? "s" : ""} {t("for you")}
          </span>
        )}
        <div className="row coursecard-row videosection-cont">
          {lpListing.length > 0 ? (
            lpListing.map((v, i) => {
              console.log(
                "DEFAULT SETTING LASTKEY",
                v.title,
                lpListing.length === i + 1
              );
              return (
                <ProductCardComponent
                  {...v}
                  key={`lp-${i + 1}`}
                  lastKey={lpListing.length === i + 1}
                  refInfo={paginateCB}
                />
              );
            })
          ) : (
            <NotFoundComponent
              width={400}
              height={419}
              showBtn={false}
              showMsg={true}
              msgLine={msgLine}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default LPListingContentComponent;
